// @flow
import defaultState from '../defaultState';
import type {
  Booking as State,
  CurrentBookingActions as Action
} from '../types';

const defaultCurrentBooking = defaultState.currentBooking;

export default function currentBooking(
  // $FlowFixMe
  state: State = defaultCurrentBooking,
  action: Action
) {
  switch (action.type) {
    case 'UPDATE_CURRENT_BOOKING':
      return {
        ...action.booking.booking
      };

    case 'CLEAR_CURRENT_BOOKING':
      return defaultCurrentBooking;

    case 'LOGOUT':
      return defaultCurrentBooking;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/currentBooking.js